import {calculateDateDifference} from './calculateDateDifference'

const countNumberOfNights = (checkIn: Date, checkOut: Date): number => {
  return calculateDateDifference(checkIn, checkOut)
}

export default countNumberOfNights
